<efx-modal [title]="'Historial'" [(show)]="showModal" [size]="modalSize.extraLarge" [showFooter]="false"
  (onHide)="didHide()">
  <div class="container d-block">

    <div class="mb-3 max-h-400px overflow-y-auto">

      <efx-data-table [dataSource]="dataSource" identityFieldName="requestId">
        <efx-grid-column field="" header="journalingTimestamp" width="20" [isVisible]="true" >
          <ng-template let-row="row" let-col let-rowIndex="rowIndex" >

            <div class="d-flex align-items-center w-100" [ngClass]="{'seguimientoReqid':row['recordAction'] === 'SOFT_DELETE'}">
              <input type="radio" class="efx-radio" id="{{row['data.header']}}"
                name="journalingTimestamp" value="{{row['data.header']}}"
                [(ngModel)]="historySelected" />
                <label for="{{row['data.header']}}">{{row.journalingTimestampFormat}}</label>
              </div>

            </ng-template>
          </efx-grid-column>


          @for (column of gridColumns; track column) {
            <efx-grid-column [field]="column.field" [header]="column.header"
              [width]="column.width" [isVisible]="column.isVisible">
              <ng-template let-row="row" let-col let-rowIndex="rowIndex" >
                <div class="w-100"  [ngClass]="{'seguimientoReqid':row['recordAction'] === 'SOFT_DELETE'}" (click)="seletedClickHistory(row['data.header'])">{{row[column.field]}}</div>
              </ng-template>
            </efx-grid-column>
          }

        </efx-data-table>
      </div>


      <div class="d-flex justify-content-end">
        <button class="efx-button-primary" [disabled]="historySelected === ''" (click)="selectedHistory()">Seleccionar
        esta versión</button>
      </div>

    </div>
  </efx-modal>
